<template>
  <!-- 100%宽度的布局组件 -->
  <div class="disp-box">
    <div class="intro-panel">
      <div class="depart-card"
           v-for="item in departs"
           :key="item.name">
        <img class="depart-card-bg"
             :src="'https://gxs-offical-website.oss-cn-shanghai.aliyuncs.com/departmentPic/'+ item.imgSrc"
             :alt="
             item.name">
        <div class="depart-info">
          <div class="name">
            {{item.name}}
          </div>
          <div class="tel">
            <!-- {{item.tel}} -->
            <a-icon type="phone" /> {{item.tel}}
          </div>
          <div class="jd">
            <a-icon type="info-circle" /> {{item.jd}}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { baseUrl } from '../../../../env'
// import { getEnterpriseEvents } from '@/request/api'
const departs = [
  { tel: '021-57321026', name: '办公室（董事会办公室、理事会办公室）', jd: '负责综合协调、保密工作、督促检查、公文处理、收发文印、信息管理、档案管理、政策调研、发展统筹、重大活动安排、对外接待、后勤保障、董事会事务、理事会事务等工作。', imgSrc: '1.png' },
  { tel: '021-57320351', name: '党群工作部（党委办公室）', jd: '负责组织（基层党建、干部工作）、纪检、宣传、统战、群团（工会、共青团、妇女）、精神文明、离休人员服务等党群工作。', imgSrc: '2.png' },
  { tel: '021-57310808-8662', name: '人力资源部', jd: '负责职工招聘、劳动合同、效能管理、绩效考核、薪酬管理、教育培训、人才、职称及技术等级管理、劳动保护、出国（境）管理、人事档案、董、监事管理、企业文化建设、退休管理等工作。', imgSrc: '3.png' },
  { tel: '021-57320675', name: '财务部（商业集团财务部、供销社财务部）', jd: '负责财务管理、预算管理、会计管理、基层财务指导、资金管理、融资管理、财税政策咨询、保险业务、经济运行分析、统计信息等工作。', imgSrc: '4.png' },
  { tel: '021-57317425', name: '资产管理部', jd: '负责资产管理、投资计划、企业调整合并、基层资产经营（指导、服务、管理、监督、检查）、建设项目管理、对外投资业务等工作。', imgSrc: '5.png' },
  { tel: '021-57310808-8613', name: '综合发展部', jd: '负责发展规划、政策研究、招商引资、品牌建设、企业管理服务等工作。', imgSrc: '6.png' },
  { tel: '021-57317903', name: '风险控制部', jd: '负责内控体系、制度建设、法务、内审（干部离任、经济责任）、重大项目风险控制、安全生产、环境综合治理、信访维稳等工作。', imgSrc: '7.png' },
  { tel: '021-57319905', name: '为农服务部', jd: '负责政府为农服务项目的落实、为农服务体系建设、为农服务业务拓展、指导基层为农业务、供销社综合改革业务、协会管理等工作。', imgSrc: '8.png' }
]

export default {
  name: 'EnterpriseIntroBlock',

  props: {
    blockTitle: String
  },

  data () {
    return {
      intro: '',
      loading: false,
      departs: departs,
      baseUrl: baseUrl
    }
  },
  methods: {
    refresh () {
    }
  },

  beforeMount () {
    this.refresh()
  }

}
</script>

<style scoped>
.disp-box {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  min-height: 400px;
  color: #222;
  overflow: hidden;
  position: relative;
}

.intro-panel {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.depart-card {
  border: 1px solid #e8e8e8;
}

.depart-card:hover {
  box-shadow: 0 0 3px 1px #00000030;
}

.depart-card-bg {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.depart-info {
  padding: 20px;
}

.depart-info .name {
  font-size: 16px;
  text-align: left;
  font-weight: 600;
  padding: 5px 0;
}

.depart-info .tel {
  font-size: 15px;
  text-align: left;
  font-weight: 600;
  color: orange;
  padding: 5px 0;
}

.depart-info .jd {
  font-size: 14px;
  text-align: left;
  color: #666;
  padding: 5px 0;
}
</style>
